export const TAGS = {
  PAYMENT_METHODS: "PaymentMethods",
} as const;
